export enum LastSeenMode {
  AnyTime = 'anyTime',
  MoreThanAWeek = 'moreThanAWeek',
  MoreThanAMonth = 'moreThanAMonth',
}
